<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="d-flex justify-center">
            <img class="logo_sportips" src="https://sportips.fr/images/Sportips_Logo_Horizontal_RVB.png" alt="" />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="pa-4 rounded elevation-1 bg-grey_1">
            <p class="text-center">Cette commande a été enregistrée avec succès. Un email de confirmation vient d'être
              envoyé aux participants inscrits</p>

            <div class="d-flex justify-center gap">
              <router-link :to="{ name: 'Administration' }"><v-btn variant="outlined" color="primary-dark">Retour à
                  l'administration</v-btn></router-link>
              <router-link :to="{ name: 'Home' }"><v-btn color="primary-dark">Retour à l'accueil</v-btn></router-link>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useBookingStore } from "@/stores/bookingStore";
import { useMainStore } from "@/stores/mainStore";
export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapStores(useBookingStore, useMainStore),
  },
  created() {
    if (!this.bookingStore.isInitialized) {
      this.$router.push({ name: "Home" });
    }
    this.mainStore.inscription_as_admin = false;
    this.bookingStore.clearState();
    this.mainStore.bookingSystem.groupe.clearState();
    this.mainStore.bookingSystem.groupe.clearLocalStorage();
  },
};
</script>

<style lang="scss" scoped></style>